const LOCAL_STORAGE_AUTH_USERNAME = 'LOCAL_STORAGE/AUTH/USERNAME'
const LOCAL_STORAGE_AUTH_KEY = 'LOCAL_STORAGE/AUTH/KEY'
const LOCAL_STORAGE_GUEST_KEY = '<guest>'

const auth = {
  getUsername: () => {
    if (typeof localStorage === 'undefined') {
      return 'Guest'
    }
    const username = localStorage.getItem(LOCAL_STORAGE_AUTH_USERNAME)
    return username !== null ? username : 'Guest'
  },

  getAuthKey: () => {
    if (typeof localStorage === 'undefined') {
      return LOCAL_STORAGE_GUEST_KEY
    }
    const authKey = localStorage.getItem(LOCAL_STORAGE_AUTH_KEY)
    return authKey !== null ? authKey : LOCAL_STORAGE_GUEST_KEY
  },

  isLoggedIn: () => {
    const authKey = auth.getAuthKey()
    return authKey !== null && authKey !== LOCAL_STORAGE_GUEST_KEY
  },

  login: (username, authKey) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(LOCAL_STORAGE_AUTH_USERNAME, username)
      localStorage.setItem(LOCAL_STORAGE_AUTH_KEY, authKey)
    }
  },

  logout: () => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(LOCAL_STORAGE_AUTH_USERNAME, 'Guest')
      localStorage.setItem(LOCAL_STORAGE_AUTH_KEY, LOCAL_STORAGE_GUEST_KEY)
    }
  },
}

export default auth
